// ============================================================
// لایه‌ی کاشی با پشتیبان
//
// اگر منبع اول کاشی نداد (قطعی سرویس، شبکه‌ی ضعیف)، خودش به منبع
// بعدیِ فهرست می‌رود.
//
// محدودیتی که باید بدانید: این منطق فقط خطای واقعی شبکه را می‌گیرد.
// سرویسی که با کد ۲۰۰ یک تصویر «کلید لازم است» برمی‌گرداند — همان
// بلایی که CARTO سرمان آورد — از دید Leaflet یک کاشی سالم است.
// برای همین فهرست منابع در tiles.ts فقط سرویس‌های بی‌کلید دارد.
//
// چرا خطاها شمرده می‌شوند: یک کاشیِ ناموجود در لبه‌ی نقشه طبیعی است
// و نباید کل منبع را کنار بگذارد.
// ============================================================

import React, { useEffect, useRef, useState } from "react";
import { TileLayer } from "react-leaflet";

import { DARK_TILE_CLASS, TILE_SOURCES, TileSource } from "./tiles";

const ERRORS_BEFORE_SWITCH = 4;

interface Props {
    dark: boolean;
    /** وقتی همه‌ی منبع‌ها شکست خوردند */
    onExhausted?: () => void;
}

const TileLayerWithFallback: React.FC<Props> = ({ dark, onExhausted }) => {
    const [index, setIndex] = useState(0);
    const errors = useRef(0);

    const source: TileSource = TILE_SOURCES[Math.min(index, TILE_SOURCES.length - 1)];

    // با عوض شدن منبع، شمارنده صفر می‌شود.
    useEffect(() => {
        errors.current = 0;
    }, [source.id]);

    return (
        <TileLayer
            key={source.id}
            url={source.url}
            attribution={source.attribution}
            maxZoom={source.maxZoom}
            className={dark ? DARK_TILE_CLASS : undefined}
            {...(source.subdomains ? { subdomains: source.subdomains } : {})}
            eventHandlers={{
                tileerror: () => {
                    errors.current += 1;
                    if (errors.current < ERRORS_BEFORE_SWITCH) return;

                    setIndex((current) => {
                        if (current + 1 < TILE_SOURCES.length) return current + 1;
                        onExhausted?.();
                        return current;
                    });
                },
            }}
        />
    );
};

export default TileLayerWithFallback;
